/**
 *
 * LightTooltip
 *
 */

import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';
import fonts from 'app/assets/styles/fonts';
import { makeThemeStyle } from 'styles/makeThemeStyle';

const useStyles = makeThemeStyle(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    color: theme.palette.common.black,
    fontSize: fonts.small,
    fontWeight: 400,
  },
}));

const LightTooltip: React.FunctionComponent<TooltipProps> = props => {
  const classes = useStyles({});

  return <Tooltip classes={classes} {...props} />;
};

export default LightTooltip;
